module.exports = __webpack_public_path__ + "static/img/license.a4cbef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/headerNav/license.png
// module id = fEBG
// module chunks = 43